import { List } from "@mui/material";
import { useState } from "react";
import styled from "styled-components";
import { theme } from "../../../helpers/theme";
import LockIcon from '@mui/icons-material/Lock';
import PaletteIcon from '@mui/icons-material/Palette';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import LanguageIcon from '@mui/icons-material/Language';
import { PasswordChange } from "./components/password-change/password-change";
import { ViewSettings } from "./components/view-settings/view-settings";
import { SettingsClientTypes } from "./settings-client-types";
import { SectionSettingsWrapper } from "./section-wrapper/section-wrapper";
import { ReactComponent as Settings_part1 } from "../../../assets/icons/settings_part1.svg";
import { ReactComponent as Settings_part2 } from "../../../assets/icons/settings_part2.svg";
import Icon from "../../../components/icon";

export const Settings = () => {
    const [openPasswordChange, setOpenPasswordChange] = useState(false);
    const [openViewSettings, setOpenViewSettings] = useState(false);
    const [openNotificationSettings, setOpenNotificationSettings] = useState(false);
    const [openLanguageSettings, setOpenLanguageSettings] = useState(false);

    const handleToggleClick = (value: number) => () => {
        switch (value) {
            case SettingsClientTypes.VIEWSETTINGS:
                setOpenViewSettings(!openViewSettings);
                break;
            case SettingsClientTypes.PASSWORDCHANGE:
                setOpenPasswordChange(!openPasswordChange);
                break;
            case SettingsClientTypes.NOTIFICATIONSETTINGS:
                setOpenNotificationSettings(!openNotificationSettings);
                break;
            case SettingsClientTypes.LANGUAGESETTINGS:
                setOpenLanguageSettings(!openLanguageSettings);
                break;
            default:
                break;
        }
    };
    return (
        <PageContainer>
            <PageTitle> {"Ustawienia"}</PageTitle>
            <PageOrganizer>
                <SettingsPart>
               <List
                sx={{
                    maxWidth: '600px',
                    bgcolor: `${theme.colors.gray04_background}`
                }}
            > 
                {/* Ustawienia hasła */}
                <SectionSettingsWrapper
                    sectionTitle={"Zmiana hasła"}
                    visibleSectionValue={SettingsClientTypes.PASSWORDCHANGE}
                    isVisibleSectionValue={openPasswordChange}
                    popoverContent={" Nowe hasło powinno posiadać od 8 do 50 znaków, w  tym  co najmniej: 1 - dużą literę, 1 - małą literę, 1 - cyfrę, 1 - znak specjalny."}
                    popoverLabel={""}
                    necessaryFildInfo={true}
                    handleToggleClick={handleToggleClick(SettingsClientTypes.PASSWORDCHANGE)}
                    setIsVisibleSectionValue={setOpenPasswordChange}
                    collapseComponent={<PasswordChange />}
                    sectionIcon={<LockIcon />}
                    disabled={false}
                /> 


                {/* Ustawienia widoku */}
                {/* <SectionSettingsWrapper
                    sectionTitle={"Ustawienia widoku"}
                    visibleSectionValue={SettingsClientTypes.VIEWSETTINGS}
                    isVisibleSectionValue={openViewSettings}
                    popoverContent={""}
                    popoverLabel={""}
                    necessaryFildInfo={false}
                    handleToggleClick={handleToggleClick(SettingsClientTypes.VIEWSETTINGS)}
                    setIsVisibleSectionValue={setOpenViewSettings}
                    collapseComponent={<ViewSettings />}
                    sectionIcon={<PaletteIcon />}
                    disabled={false}
                />  */}



                {/* Ustawienia powiadomień */}
                {/* <SectionSettingsWrapper
                    sectionTitle={"Powiadomienia"}
                    visibleSectionValue={SettingsClientTypes.NOTIFICATIONSETTINGS}
                    isVisibleSectionValue={openNotificationSettings}
                    popoverContent={""}
                    popoverLabel={""}
                    necessaryFildInfo={false}
                    handleToggleClick={handleToggleClick(SettingsClientTypes.NOTIFICATIONSETTINGS)}
                    setIsVisibleSectionValue={setOpenNotificationSettings}
                    collapseComponent={<>Test</>}
                    sectionIcon={<NotificationsActiveIcon />}
                    disabled={true}
                />  */}

                {/* Ustawienia języka */}
                 {/* <SectionSettingsWrapper
                    sectionTitle={"Język"}
                    visibleSectionValue={SettingsClientTypes.LANGUAGESETTINGS}
                    isVisibleSectionValue={openLanguageSettings}
                    popoverContent={""}
                    popoverLabel={""}
                    necessaryFildInfo={false}
                    handleToggleClick={handleToggleClick(SettingsClientTypes.LANGUAGESETTINGS)}
                    setIsVisibleSectionValue={setOpenLanguageSettings}
                    collapseComponent={<>Test</>}
                    sectionIcon={<LanguageIcon />}
                    disabled={true}
                /> */}
                
              </List> 
                </SettingsPart>
               <ImagePart>
              <Icon
                        height="174px"
                        width="234px"
                        noPadding
                        icon={<Settings_part1 />}
                      />
                <Icon
                        height="148px"
                        width="213px"
                        noPadding
                        icon={<Settings_part2 />}
                      /> 
              </ImagePart>
            </PageOrganizer>
        </PageContainer >
    );
};

const PageContainer = styled.div`
padding: 0px 10px;
  @media (min-width: 1025px) {
    margin-left:230px;
    margin-top:-18px;
    margin-right: 50px;
  }
`;


const PageTitle = styled.h2`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
`;

const PageOrganizer=styled.div`
display:flex;
  flex-direction:column;
@media (min-width: 600px) {
  display:flex;
  flex-direction:row;
  justify-content: space-between;
  column-gap:20px;
  }
`;
const SettingsPart=styled.div`
width:60%;
min-width:230px;
@media (min-width: 800px) {
    width:60%;
    }
    @media (max-width: 600px) {
        width:100%;
        }
`;
const ImagePart=styled.div`
margin:auto auto;
@media (min-width: 800px) {
    }
`;
